(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('categoryAndSkillSearch', categoryAndSkillSearch);

    function categoryAndSkillSearch() {
        return {
            templateUrl: '/app/directives/category-and-skill-search.tpl.html',
            scope: {
                selectedFilter: '=',
                selectedFilters: '='
            },
            controller: CategoryAndSkillSearchController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function CategoryAndSkillSearchController(dataService) {
        var vm = this;
        
        vm.search = search;
        
        function search(text) {
            return dataService
                .searchCategoriesAndSkills(text)
                .then(response => {
                    var filters = vm.selectedFilters || [];
                    return response.results;
                });
        }
    }

})();